<template>
  <li
    v-if="canViewHorizontalNavMenuLink(item)"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
    @dragstart="onDragStart($event, item)"
    @dragend="onDragEnd"
  >
    <b-link
      v-bind="linkProps"
      class="dropdown-item"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
        size="24"
      />
      <span class="text-capitalize">{{ $tc(item.title, 2) }}</span>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuLink from './useHorizontalNavMenuLink'
import mixinHorizontalNavMenuLink from './mixinHorizontalNavMenuLink'
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import store from '@/store';

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useHorizontalNavMenuLink(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuLink } = useAclUtils()

    //DATA
    const draggableMenus = [
      'dmp_alarms',
      'dmp_logs',
      'dmp_panels',
      'dmp_profiles',
      'unit',
      'omnicloud_watchlist',
      'omnicloud_face_recognition',
      'alarm',
      'detection_event',
      'crisis_form',
      'operational_processes',
      'teams',
      'directory',
      'patrol_logs',
      'unit_log',
      'unit_commanders',
      'external_personnel_access_control',
      'hanwha_logs',
    ];

    //METHODS
    const onDragEnd = () => {
      store.dispatch('grid/resetSlotSelection')
    }

    const onDragStart = (event, data) => {
      const { route } = data;

      const canDragMenu = draggableMenus.includes(route);

      if (canDragMenu) {
        event.dataTransfer.effectAllowed = 'copy';
        event.dataTransfer.setData('text/plain', route);

        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.DRAGGABLE_MENU,
          name: 'Draggable menu',
          data: {
            showFilters: false,
            type: route
          },
          source: SOURCES.MAIN_SEARCH
        });
      }
    }

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewHorizontalNavMenuLink,

      // i18n
      t,

      onDragEnd,
      onDragStart,
    }
  },

}
</script>
